export const START_LOAD_FEEDS = 'START_LOAD_FEEDS';
export const FINISH_LOAD_FEEDS = 'FINISH_LOAD_FEEDS';
export const ERROR_LOAD_FEEDS = 'ERROR_LOAD_FEEDS';


/*add feed to read*/
export const START_ADD_READ_FEED = 'START_ADD_READ_FEED';
export const FINISH_ADD_READ_FEED = 'FINISH_ADD_READ_FEED';
export const ERROR_ADD_READ_FEED = 'ERROR_ADD_READ_FEED';

/*add feed to bookmark*/
export const START_ADD_BOOKMARK_FEED = 'START_ADD_BOOKMARK_FEED';
export const FINISH_ADD_BOOKMARK_FEED = 'FINISH_ADD_BOOKMARK_FEED';
export const ERROR_ADD_BOOKMARK_FEED = 'ERROR_ADD_BOOKMARK_FEED';

/*load bookmarks*/
export const START_LOAD_BOOKMARKS = 'START_LOAD_BOOKMARKS';
export const FINISH_LOAD_BOOKMARKS = 'FINISH_LOAD_BOOKMARKS';
export const ERROR_LOAD_BOOKMARKS = 'ERROR_LOAD_BOOKMARKS';

/*remove bookmarks*/
export const START_REMOVE_BOOKMARK = "START_REMOVE_BOOKMARK";
export const FINISH_REMOVE_BOOKMARK = "FINISH_REMOVE_BOOKMARK";
export const ERROR_REMOVE_BOOKMARK = "ERROR_REMOVE_BOOKMARK";


/*load feed info*/
export const START_LOAD_FEED = 'START_LOAD_FEED';
export const FINISH_LOAD_FEED = 'FINISH_LOAD_FEED';
export const ERROR_LOAD_FEED = 'ERROR_LOAD_FEED';


// WEBPACK FOOTER //
// ./src/models/feeds/constants.js